import gsap from 'gsap';

var ANIM_DURATION = 0.45;
var ANIM_EASE_OPEN = 'power2.out';
var ANIM_EASE_CLOSE = 'power2.inOut';

/** .vertical rotation: open = plus (0°), closed = minus (90°) */
var ROTATION_OPEN = 0;
var ROTATION_CLOSED = 90;

var FloorplanHeader = function (options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FloorplanHeader',
	};

	$.extend(true, this.options, options);

	this.panels = [];
	this._onResize = null;

};

FloorplanHeader.prototype.init = function () {

	var self = this;
	var $root = this.options.$el;
	var $accordions = $root.find('.accordion2_component');

	if (!$accordions.length) {
		return;
	}

	$accordions.each(function (index) {
		var $comp = $(this);
		var panel = {
			$comp: $comp,
			$top: $comp.find('.accordion2_top'),
			$bottom: $comp.find('.accordion2_bottom'),
			$inner: $comp.find('.floorplan-header_dropdown-bottom'),
			$vertical: $comp.find('.vertical'),
			isOpen: index === 0,
		};

		self.panels.push(panel);

		panel.$top.on('click', function () {
			if (panel.isOpen) {
				self.closePanel(panel);
			} else {
				self.openPanel(panel);
			}
		});
	});

	this.panels.forEach(function (panel, i) {
		self.setInitialPanelState(panel, i === 0);
	});

	this._onResize = _.debounce(function () {
		self.refreshOpenHeights();
	}, 150);

	$(window).on('resize.floorplanHeader', this._onResize);

};

FloorplanHeader.prototype.setInitialPanelState = function (panel, isFirst) {

	var bottom = panel.$bottom[0];
	var vertical = panel.$vertical[0];

	gsap.killTweensOf(vertical ? [bottom, vertical] : bottom);

	gsap.set(bottom, { overflow: 'hidden' });

	if (isFirst) {
		panel.isOpen = true;
		panel.$comp.addClass('is-open');
		if (vertical) {
			gsap.set(vertical, { rotation: ROTATION_OPEN, transformOrigin: '50% 50%' });
		}
		gsap.set(bottom, { height: 'auto', opacity: 1 });
	} else {
		panel.isOpen = false;
		panel.$comp.removeClass('is-open');
		if (vertical) {
			gsap.set(vertical, { rotation: ROTATION_CLOSED, transformOrigin: '50% 50%' });
		}
		gsap.set(bottom, { height: 0, opacity: 0 });
		panel.$inner.css('overflow', 'hidden');
	}

};

FloorplanHeader.prototype.openPanel = function (panel) {

	var bottom = panel.$bottom[0];
	var vertical = panel.$vertical[0];

	gsap.killTweensOf(vertical ? [bottom, vertical] : bottom);

	panel.$inner.css('overflow', 'hidden');
	gsap.set(bottom, { overflow: 'hidden' });

	gsap.set(bottom, { height: 'auto' });
	var target = bottom.scrollHeight;
	gsap.set(bottom, { height: 0, opacity: 0 });

	panel.isOpen = true;
	panel.$comp.addClass('is-open');

	gsap.to(bottom, {
		height: target,
		opacity: 1,
		duration: ANIM_DURATION,
		ease: ANIM_EASE_OPEN,
		onComplete: function () {
			gsap.set(bottom, { height: 'auto' });
			panel.$inner.css('overflow', '');
		},
	});

	if (vertical) {
		gsap.to(vertical, {
			rotation: ROTATION_OPEN,
			duration: ANIM_DURATION,
			ease: ANIM_EASE_OPEN,
			transformOrigin: '50% 50%',
		});
	}

};

FloorplanHeader.prototype.closePanel = function (panel) {

	var bottom = panel.$bottom[0];
	var vertical = panel.$vertical[0];

	gsap.killTweensOf(vertical ? [bottom, vertical] : bottom);

	panel.$inner.css('overflow', 'hidden');
	gsap.set(bottom, { overflow: 'hidden' });

	var currentH = bottom.scrollHeight;
	gsap.set(bottom, { height: currentH, opacity: 1 });

	panel.isOpen = false;
	panel.$comp.removeClass('is-open');

	gsap.to(bottom, {
		height: 0,
		opacity: 0,
		duration: ANIM_DURATION,
		ease: ANIM_EASE_CLOSE,
	});

	if (vertical) {
		gsap.to(vertical, {
			rotation: ROTATION_CLOSED,
			duration: ANIM_DURATION,
			ease: ANIM_EASE_CLOSE,
			transformOrigin: '50% 50%',
		});
	}

};

FloorplanHeader.prototype.refreshOpenHeights = function () {

	this.panels.forEach(function (panel) {
		if (!panel.isOpen) {
			return;
		}
		var bottom = panel.$bottom[0];
		if (!gsap.getTweensOf(bottom).length) {
			gsap.set(bottom, { height: 'auto' });
		}
	});

};

export default FloorplanHeader;
